import { createAction, createReducer } from "redux-act";
import { Sort } from "@evergis/ui";

import { reducerRegistry } from "../reducerRegistry";

import { TableFilterState } from "../../modules/Table/types";
import { TableSelection, TableSpecialFilter, TableState } from "./types";
import { FeatureDcExtended } from "../selectFeatures/types";

const reducerName = "table";

const initialState: TableState = {};

export const reducer = createReducer({}, initialState);

export const setQueryTableData = createAction<TableState["queryData"]>(`${reducerName}/set-query-data`);

export const setTableLayerId = createAction<string>(`${reducerName}/set-layer-id`);

export const updateTableFilters = createAction<Record<string, TableFilterState>>(`${reducerName}/update-table-filters`);

export const updateTableFilterConditions = createAction<Record<string, string>>(
  `${reducerName}/update-table-filter-conditions`,
);

export const updateTableSelection = createAction<Record<string, TableSelection>>(
  `${reducerName}/update-table-selection`,
);

export const updateTableSort = createAction<Record<string, Sort>>(`${reducerName}/update-table-sort`);

export const updateSpecialFilter = createAction<TableSpecialFilter>(`${reducerName}/update-is-special-filter`);

export const setTableSelectedFeature = createAction<FeatureDcExtended>(`${reducerName}/set-table-selected-feature`);

reducer.on(setQueryTableData, (state, queryData) => ({ ...state, queryData }));

reducer.on(setTableLayerId, (state, layerId) => ({ ...state, layerId }));

reducer.on(updateTableFilters, (state, tableFilters) => ({
  ...state,
  tableFilters,
}));

reducer.on(updateTableFilterConditions, (state, tableFilterConditions) => ({
  ...state,
  tableFilterConditions,
}));

reducer.on(updateTableSelection, (state, tableSelection) => ({
  ...state,
  tableSelection,
}));

reducer.on(updateTableSort, (state, tableSort) => ({
  ...state,
  tableSort,
}));

reducer.on(updateSpecialFilter, (state, specialFilter) => ({
  ...state,
  specialFilter,
}));

reducer.on(setTableSelectedFeature, (state, selectedFeature) => ({
  ...state,
  selectedFeature,
}));

reducerRegistry.register(reducerName, reducer);
